const QUOTE_REGEX = /bloomberg.com\/quote\/([\w%/]+:[\w]+)/;

export default function getTickerFromUrl(snapshotTicker: string | undefined) {
    if (!snapshotTicker || !QUOTE_REGEX.test(snapshotTicker)) {
        return snapshotTicker;
    }

    const res = snapshotTicker.match(QUOTE_REGEX);

    return res?.length && res?.length > 1 ? decodeURI(res[1]) : snapshotTicker;
}
